import { formatCountdown, formatTime } from '../../../core/utils/format';

import './styles/Countdown.css';

// Presentational only — it receives milliseconds and renders them. Keeping it
// context-free is what lets it live in common/ (TSS vite/01: common → core).

export default function Countdown({
    msRemaining,
    intervalMs,
    nextAt,
    isDrawing = false,
    onSimulate,
    compact = false,
}) {
    const progress = Math.min(1, Math.max(0, 1 - msRemaining / intervalMs));

    const classes = [
        'countdown',
        compact ? 'countdown--compact' : '',
        isDrawing ? 'countdown--drawing' : '',
    ].filter(Boolean).join(' ');

    return (
        <div className={classes}>
            <div className="countdown__head">
                <span className="countdown__label">
                    {isDrawing ? 'Sorteando ahora' : 'Próximo sorteo en'}
                </span>
                {onSimulate && (
                    <button
                        type="button"
                        className="countdown__simulate"
                        onClick={onSimulate}
                        title="Control de demo: adelanta el reloj hasta el siguiente sorteo"
                    >
                        ⚡ Simular
                    </button>
                )}
            </div>

            <strong className="countdown__value">{formatCountdown(msRemaining)}</strong>

            <div className="countdown__track">
                <span className="countdown__fill" style={{ '--progress': progress }} />
            </div>

            <span className="countdown__next">Se juega a las {formatTime(nextAt)}</span>
        </div>
    );
}
